( function ( $ ) {

	$( document ).ready( function ( $ ) {
		// Your site's jQuery goes inside this .ready() function.
		console.log( "jQuery loaded" );
		/*****************************************************************
      Mobile hover fix for iOS devices + other mobile device scrolls
    ******************************************************************/

		$( '*' ).on( 'touchstart', function () {
			$( this ).trigger( 'hover' );
		} ).on( 'touchend', function () {
			$( this ).trigger( 'hover' );
		} );

		/*******************************************************************
      Nav Top Level Menu Item: functioanlity fix for Mobile
    ********************************************************************/

		$( '.menu-item-has-children > a' ).click( function ( e ) {
			if ( $( window ).width() < 950 ) {
				e.preventDefault();
				console.log( 'No clicking on mobile.' );
				return false;
			}
		} );

		/*****************************************************************
      Tabbing Navigation for Footer
    ******************************************************************/
		$( '.footernav button' ).first().addClass( 'active' );
		$( '.footermobile .footerinfo div' ).first().addClass( 'active' );

		$( '.footernav button' ).click( function ( e ) {
			e.preventDefault();

			var tabs = $( ".footernav" ).children(),
				info = $( ".footerinfo" ).children(),
				clickedTab = $( this ),
				i = clickedTab.index(),
				newInfo = info[ i ];

			tabs.removeClass( "active" );
			info.removeClass( "active" );
			clickedTab.addClass( "active" );
			$( newInfo ).addClass( "active" );
		} );

		/*****************************************************************
      Tabbing Navigation for Values Section on About Page
    ******************************************************************/
		$( '.values-nav button' ).first().addClass( 'active' );
		$( '.value-descriptions .desc' ).first().addClass( 'active' );

		$( '.values-nav button' ).click( function ( e ) {
			e.preventDefault();

			var tabs = $( ".values-nav" ).children(),
				info = $( ".value-descriptions" ).children(),
				clickedTab = $( this ),
				i = clickedTab.index(),
				newInfo = info[ i ];

			tabs.removeClass( "active" );
			info.removeClass( "active" );
			clickedTab.addClass( "active" );
			$( newInfo ).addClass( "active" );
		} );

		/*****************************************************************
      Tabbing Navigation for Employment page info
    ******************************************************************/
		$( '.careertabs button' ).first().addClass( 'active' );
		$( '.careerinfo .info' ).first().addClass( 'active' );

		$( '.careertabs button' ).click( function ( e ) {
			e.preventDefault();

			var tabs = $( ".careertabs" ).children(),
				info = $( ".careerinfo" ).children(),
				clickedTab = $( this ),
				i = clickedTab.index(),
				newInfo = info[ i ];

			tabs.removeClass( "active" );
			info.removeClass( "active" );
			clickedTab.addClass( "active" );
			$( newInfo ).addClass( "active" );
		} );

		/*****************************************************************
      Add and remove Background to Navbar after scrolling
    ******************************************************************/
		$( function () {
			var didScroll;
			var lastScrollTop = 0;
			var delta = 5;
			var navbarHeight = $( '#navbar' ).outerHeight();

			$( window ).scroll( function ( event ) {
				didScroll = true;
			} );

			setInterval( function () {
				if ( didScroll ) {
					hasScrolled();
					didScroll = false;
				}
			}, 250 );

			function hasScrolled() {

				if ( $( window ).scrollTop() === 0 ) {
					$( '#navbar' ).removeClass( 'scrolled' ).addClass( 'istop' );
				} else {
					$( '#navbar' ).removeClass( 'istop' ).addClass( 'scrolled' );
				}

				var st = $( this ).scrollTop();
				lastScrollTop = st;
			}
		}() );

		/*****************************************************************
      Menu Button & Request a Quote Functionality
    ******************************************************************/
		$( '#menubtn' ).click( function ( event ) {
			if ( $( 'body' ).hasClass( 'quote-active' ) ) {
				$( 'body, #quotemodal, .quotebtn' ).removeClass( 'quote-active' );
				$( 'nav > .top, nav > .bot' ).delay( 750 ).animate( { opacity: 1 }, 350 );
				$( 'body, #menubtn, nav' ).addClass( 'menu-active' );
			} else if ( $( 'body' ).hasClass( 'menu-active' ) ) {
				$( 'body, #menubtn, nav' ).removeClass( 'menu-active' );
				$( 'nav > .top, nav > .bot' ).fadeTo( 100, 0 );
			} else {
				$( 'body, #menubtn, nav' ).addClass( 'menu-active' );
				$( 'nav > .top, nav > .bot' ).delay( 750 ).animate( { opacity: 1 }, 350 );

			}
		} );

		$( '.quotebtn' ).click( function ( event ) {
			if ( $( 'body' ).hasClass( 'menu-active' ) ) {
				$( 'body, #menubtn, nav' ).removeClass( 'menu-active' );
				$( 'nav > .top, nav > .bot' ).fadeTo( 100, 0 );
				$( 'body, #quotemodal, .quotebtn' ).addClass( 'quote-active' );
			} else if ( $( 'body' ).hasClass( 'quote-active' ) ) {
				$( 'body, #quotemodal, .quotebtn' ).removeClass( 'quote-active' );
			} else {
				$( 'body, #quotemodal, .quotebtn' ).addClass( 'quote-active' );
			}
		} );

		/* For Hovering of Menu Items in the Nav */
		$( '.menu-item:not(.issub) > a, .sub-menu' ).hover( function () {

			if ( $( window ).width() > 950 ) {

				$( '.menu-item:not(.issub) > a' ).each( function ( index, val ) {
					$( this ).addClass( 'hovered' );
				} );
			}

		}, function () {

			$( '.menu-item > a' ).each( function ( index, val ) {
				$( this ).removeClass( 'hovered' );
			} );

		} );

		/* =============================================================================================================
		  Dynamic Image Delivery for Images
		 ============================================================================================================= */
		function changeBgImgSrc( container, srcset ) {
			var wWidth = $( window ).width();
			if ( window.devicePixelRatio >= 2 ) {
				wWidth = wWidth * 2;
			}
			$.each( srcset, function ( index, i ) {
				//if the next one does exist use the biggest one
				if ( srcset[ index + 1 ] == undefined ) {
					container.css( { 'background-image': 'url(' + srcset[ srcset.length - 1 ].url + ')' } );
				} else {
					//if the current items width is smaller than the screen size and the width of the next item is bigger than the screen size use the current item.
					if ( i.width > wWidth ) {
						container.css( { 'background-image': 'url(' + i.url + ')' } );
						return false;
					}
				}
			} );
		}

		var $resimgs = $( ':not(.static)[data-src-set]' );

		$resimgs.each( function () {
			var container = $( this )
			var sources = $( this ).data( 'src-set' );
			var groups = sources.split( ',' );
			var srcset = [];

			$.each( groups, function ( index, i ) {
				var current = this.trim().split( ' ' );
				srcset.push( {
					width: parseInt( current[ 1 ].replace( 'w', '' ), 10 ),
					url: current[ 0 ]
				} );
			} );

			function compareWidth( a, b ) {
				if ( a.width < b.width )
					return -1;
				if ( a.width > b.width )
					return 1;
				return 0;
			}

			srcset.sort( compareWidth );
			changeBgImgSrc( container, srcset )
		} );

		/* =============================================================================================================
  END *** Dynamic Image Delivery for Images
 ============================================================================================================= */

		/*****************************************************************
		  For when we do a img src="example.svg" SVG use instead of the 
		  <svg> html markup
		******************************************************************/

		$( 'img.svg' ).each( function () {
			var $img = $( this );
			var imgID = $img.attr( 'id' );
			var imgClass = $img.attr( 'class' );
			var imgURL = $img.attr( 'src' );

			$.get( imgURL, function ( data ) {
				// Get the SVG tag, ignore the rest
				var $svg = $( data ).find( 'svg' );

				// Add replaced image's ID to the new SVG
				if ( typeof imgID !== 'undefined' ) {
					$svg = $svg.attr( 'id', imgID );
				}
				// Add replaced image's classes to the new SVG
				if ( typeof imgClass !== 'undefined' ) {
					$svg = $svg.attr( 'class', imgClass + ' replaced-svg' );
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr( 'xmlns:a' );

				// Check if the viewport is set, if the viewport is not set the SVG wont't scale.
				if ( !$svg.attr( 'viewBox' ) && $svg.attr( 'height' ) && $svg.attr( 'width' ) ) {
					$svg.attr( 'viewBox', '0 0 ' + $svg.attr( 'height' ) + ' ' + $svg.attr( 'width' ) )
				}

				// Replace image with new SVG
				$img.replaceWith( $svg );

			}, 'xml' );

		} );

		/*****************************************************************
		  Owl Carousel
		******************************************************************/

		$( ".testmonial-slider" ).each( function () {
			var testimonials = $( this );
			testimonials.owlCarousel( {
				items: 1,
				singleItem: true,
				rewind: true,
				nav: false,
				dots: true
			} );
		} );

		$( ".services-carousel" ).each( function () {
			var testimonials = $( this );
			testimonials.owlCarousel( {
				items: 1,
				singleItem: true,
				rewind: true,
				nav: false,
				dots: true
			} );
		} );

		var brandSlide = $( ".brand-slider" );
		brandSlide.owlCarousel( {
			autoplay: true,
			autoplayTimeout: 3500,
			autoplaySpeed: 2850,
			loop: true,
			responsive: {
				0: {
					items: 2,
				},
				768: {
					items: 3,
				},
				950: {
					items: 2,
				},
			},
			nav: false,
			dots: false,
			touchDrag: false,
			mouseDrag: false
		} );

		/*****************************************************************
		  Clients Page dynamically change images at random
		******************************************************************/

		$( '.client-logo-container' ).each( function () {

			logoLinks.splice( 0, 16 );

			// Fisher-Yates shuffle to randomly select
			function shuffle( array ) {
				var m = array.length,
					t, i;
				// While there remain elements to shuffle…
				while ( m ) {
					// Pick a remaining element…
					i = Math.floor( Math.random() * m-- );
					// And swap it with the current element.
					t = array[ m ];
					array[ m ] = array[ i ];
					array[ i ] = t;
				}
				return array;
			}

			// Changing the logos
			setInterval( function () {
				var items = shuffle( $( ".logo-item" ) ).slice( 0, 4 );

				// generate 4 random images to use & then remove them from the pool
				temp = [];
				$( items ).each( function () {
					var a = logoLinks[ Math.floor( Math.random() * logoLinks.length ) ];
					var b = logoLinks.indexOf( a );
					logoLinks.splice( b, 1 );
					temp.push( a );
				} );

				// add the old images back into the pool of images
				$( items ).each( function () {
					logoLinks.push( $( this ).children().attr( 'src' ) );
				} );

				// switch the new images in
				var iTemp = 0;
				// switch the new images in
				$( items ).each( function () {
					$( this ).fadeTo( 400, 0 );
					$( this ).delay( 400 ).fadeTo( 500, 1 ).children().delay( 400 ).attr( 'src', temp[ iTemp ] );
					iTemp++;
				} );

			}, 10000 );

		} );

		/*****************************************************************
    	Scroll Magic jQuery Plugin
  	******************************************************************/

		// init scroll magic
		var smcontroller = new ScrollMagic.Controller();

		/*** background text in the intro sections panning left ***/
		$( '.bgtxt-down' ).each( function () {

			var slideAnim = new TimelineMax()
				.to( $( this ).children( '.bgtxt-container' ).children( '.bgtxt' ), 1, { y: '225px' } )
				.to( $( this ).children( '.bgtxt-container' ).children( '.bgtxt' ), .25, { opacity: ".2" }, "-=.25" );

			var slideTextLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .35,
					duration: '100%'
				} )
				.setTween( slideAnim )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** background text in the intro sections panning left ***/
		$( '.bgtxt-left' ).each( function () {

			var slideAnim = new TimelineMax()
				.to( $( this ).children( '.bgtxt-container' ).children( '.bgtxt' ), 1, { x: '-20%' } )
				.to( $( this ).children( '.bgtxt-container' ).children( '.bgtxt' ), .25, { opacity: ".3" }, "-=.25" );

			var slideTextLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7,
					duration: '100%'
				} )
				.setTween( slideAnim )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** background text in the intro sections panning right ***/
		$( '.bgtxt-right' ).each( function () {

			var slideAnim = new TimelineMax()
				.to( $( this ).children( '.bgtxt-container' ).children( '.bgtxt' ), 1, { x: '20%' } )
				.to( $( this ).children( '.bgtxt-container' ).children( '.bgtxt' ), .25, { opacity: ".3" }, "-=.25" );

			var slideTextRight = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7,
					duration: '100%'
				} )
				.setTween( slideAnim )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** homepage fancy grid ***/
		$( '.fancy-grid' ).each( function () {

			var slideX = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .4,
					duration: '100%'
				} )
				.setTween( $( this ).children( '.top' ).children( '.left' ).children( '.animate-one' ), { top: "42.5vw" } )
				//.addIndicators()
				.addTo( smcontroller );

			var slideText = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7,
					duration: '100%'
				} )
				.setTween( $( this ).children( '.bot' ).children( '.one' ).children( '.slide-right-text' ), { left: "-10vw" } )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Standard Text Section minor effect ***/
		$( '.circle-slide' ).each( function () {
			var showText = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .35
				} )
				.setClassToggle( this, 'visible' )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** About Page Team image section ***/
		$( '.fade-image-container' ).each( function () {

			var fadeSection = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .5,
					duration: '70%'
				} )
				.setClassToggle( this.children[ 1 ], 'visible' )
				.setTween( this.children[ 0 ], { opacity: "0" } )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Fade items in from the Bottom on viewport enter ***/
		$( '.fade-from-bottom' ).each( function () {
			var me = $( this );
			var showFromLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .8
				} )
				.on( 'start', function ( event ) {
					$( me ).addClass( 'visible' )
				} )
				//.addIndicators()
				.addTo( smcontroller );
		} );
		$( '.fade-from-right' ).each( function () {
			var me = $( this );
			var showFromRight = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .8
				} )
				.on( 'start', function ( event ) {
					$( me ).addClass( 'visible' )
				} )
				//.addIndicators()
				.addTo( smcontroller );
		} );
		$( '.fade-from-left' ).each( function () {
			var me = $( this );
			var showFromLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .8
				} )
				.on( 'start', function ( event ) {
					$( me ).addClass( 'visible' )
				} )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Commercial Single text highlight animation ***/
		$( '.leadin' ).each( function () {
			var me = $( this );
			var showFromLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7
				} )
				.on( 'start', function ( event ) {
					$( me ).addClass( 'visible' )
				} )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Special Events Intro Text ***/
		$( '.special-events .left' ).each( function () {
			var me = $( this );
			var showFromLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7
				} )
				.setClassToggle( this, 'visible' )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Parking Management Intro Text ***/
		$( '.parking-management .right' ).each( function () {
			var me = $( this );
			var showFromLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7
				} )
				.setClassToggle( this, 'visible' )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Subtle highlight background text ***/
		$( '.highlight' ).each( function () {
			var me = $( this );
			var showFromLeft = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .7
				} )
				.setClassToggle( this, 'visible' )
				//.addIndicators()
				.addTo( smcontroller );
		} );

		/*** Employment Page 8 min mile text effect ***/
		$( '.overlaytxt' ).each( function () {

			var textEffect = new ScrollMagic.Scene( {
					triggerElement: this,
					triggerHook: .5,
					duration: '70%'
				} )
				.setTween( this, { letterSpacing: "0.15em" } )
				//.addIndicators()
				.addTo( smcontroller );
		} );

	} );

	$( window ).load( function () {

		/*****************************************************************
		  Owl Carousels that need to be in the LOAD function
		******************************************************************/

		$( ".icons-mobile" ).each( function () {
			var icons = $( this );
			icons.owlCarousel( {
				center: true,
				loop: true,
				items: 3,
				rewind: true,
				nav: false,
				dots: false
			} );
		} );

	} );

}( jQuery ) );